import React, { useState } from 'react';
import Icon, { IconName } from './icons/Icon';
import Tooltip, { TooltipPosition } from './Tooltip';
import './IconButton.css';

interface IconButtonProps {
  icon: IconName;
  onClick: () => void;
  type?: 'primary' | 'ghost';
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
  tooltip?: string;
  tooltipPosition?: TooltipPosition;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  type = 'ghost',
  disabled = false,
  className = '',
  'aria-label': ariaLabel,
  tooltip,
  tooltipPosition = 'top-right'
}) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div className="icon-button-container">
      {tooltip && (
        <Tooltip 
          text={tooltip} 
          visible={isHovered && !disabled}
          position={tooltipPosition}
        />
      )}
      <button
        className={`icon-button icon-button--${type} ${disabled ? 'icon-button--disabled' : ''} ${className}`}
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        type="button"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="icon-button__variable">
          <div className="icon-button__state">
            <Icon name={icon} size={24} />
          </div>
        </div>
      </button>
    </div>
  );
};

export default IconButton;